import { render, staticRenderFns } from "./vedioList.vue?vue&type=template&id=473ec5fd&scoped=true"
import script from "./vedioList.vue?vue&type=script&lang=js"
export * from "./vedioList.vue?vue&type=script&lang=js"
import style0 from "./vedioList.vue?vue&type=style&index=0&id=473ec5fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473ec5fd",
  null
  
)

export default component.exports